export default class AuthenticationError extends Error {
  constructor(
    message: string,
    public originalError?: unknown,
  ) {
    super(message)
    this.name = 'AuthenticationError'
  }
}
